export const paths = {
    login: '',
    createAccount: 'create-account',
    forgotPassword: 'forgot-password',
    setPassword: 'set-password',
    account: 'account',
    employees: 'employees',
    invitations: 'invitations',
    newEmployee: 'employees/new',
    appointment: 'make-appointment',
    optOut: 'opt-out',
};
